import { render } from "./email-opt-in-checkbox.vue?vue&type=template&id=6cb7a877&lang=pug"
import script from "./email-opt-in-checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./email-opt-in-checkbox.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__